import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { CRO_RESCHEDULE_TABLE_HEAD } from "../../components/datagrid/rechedule/CrorescheduleTableHead";
import { getRescheduledSession } from "../../redux/features/batchSlice";
import PostSchedule from "./Postreschedule";
import { BATCH_SESSION_RESCHEDULE } from "../../components/datagrid/myworkspace/cro/BatchSessionReschedule";
import { Icon } from "@iconify/react/dist/iconify.js";

const BatchSessionReschedule = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, reschedules } = useSelector((state) => state.batch);
  const [addOpen, setAddOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getRescheduledSession(data));
    }
  }, [pageNum, gridSize]);

  const columns = useMemo(
    () => [
      ...BATCH_SESSION_RESCHEDULE,
      {
        field: "action",
        headerName: "Action",
        width: 200,
        renderCell: (params) => {
          return (
            <Button
              size="small"
              color="secondary"
              variant="outlined"
              startIcon={<Icon icon={"bxs:calendar"} width={18} height={18} />}
              onClick={() => {
                setAddOpen(true);
                setSelectedRow(params.row);
              }}
            >
              Reschedule
            </Button>
          );
        },
      },
    ],
    BATCH_SESSION_RESCHEDULE
  );

  return (
    <GlobalWrapper title={"Session Reschedule"}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", pb: 2 }}>
        <Stack direction={"row"} spacing={2}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Date"
                value={value}
                views={["year", "month"]}
                onChange={(newValue) => setValue(newValue)}
                format="YYYY-MM"
              />
            </LocalizationProvider>
          </Box>
        </Stack>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={columns}
          rows={reschedules?.data}
          meta={reschedules?.meta?.totalRecords || 0}
          rowUniqueId="sl_no"
          loading={loading}
          rowClick={false}
        />
      </Box>
      {addOpen && selectedRow && (
        <PostSchedule
          rowData={selectedRow}
          dispatchdata={data}
          open={addOpen}
          setOpen={setAddOpen}
        />
      )}
    </GlobalWrapper>
  );
};

export default BatchSessionReschedule;
